var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcePlanningMast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.095 12.6542C19.6868 9.03116 17.5939 6.05991 14.7909 4.89702V10.4714C14.7909 10.8004 14.5229 11.0684 14.1938 11.0684C13.8648 11.0684 13.5968 10.8006 13.5968 10.4714V4.52154C13.1344 4.42217 12.6595 4.3623 12.1727 4.3623C11.6901 4.3623 11.2195 4.42339 10.7612 4.52276V10.4714C10.7612 10.8004 10.493 11.0684 10.1654 11.0684C9.83489 11.0684 9.56692 10.8006 9.56692 10.4714V4.89987C6.77078 6.06805 4.6641 9.05051 4.22896 12.6542H2.16504V14.2062H22.165V12.6542H20.095Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5475 14.7773H3.78221V17.9787H4.83901V20.1556L10.9347 20.1625L12.1647 17.8303L13.395 20.1625L19.4907 20.1556V17.9787H20.5475V14.7773ZM11.4282 16.9325L10.2871 19.1139L5.90151 19.1117V15.8435H11.4282V16.9325ZM18.4284 19.1117L14.0423 19.1139L12.9012 16.9325V15.8435H18.4284V19.1117Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcePlanningMast);
export default __webpack_public_path__ + "static/media/resource-planning-mast.6d93ea77014882ffd9a6fe900c92fb33.svg";
export { ForwardRef as ReactComponent };